import type { TranslateFn } from '../i18n/operationLabels';

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const SUBTITLE_API_KEYS = ['sub_title', 'subtitle', 'subTitle'] as const;

/** Listing subtitle from API `sub_title` when set; otherwise `null` (no marketing fallback). */
export function assetRecordSubTitle(data: Record<string, unknown>): string | null {
  for (const key of SUBTITLE_API_KEYS) {
    const raw = data[key];
    if (typeof raw === 'string' && raw.trim()) {
      return raw.trim();
    }
  }
  return null;
}

const CREATED_DATE_KEYS = ['registration_date', 'registered_at', 'created_at'] as const;

function parseAssetCreatedMs(data: Record<string, unknown>): number | null {
  for (const key of CREATED_DATE_KEYS) {
    const raw = data[key];
    if (typeof raw === 'string' && raw.trim()) {
      const ms = Date.parse(raw.trim());
      if (Number.isFinite(ms)) {
        return ms;
      }
    }
  }
  return null;
}

/** True when the asset was created/registered within the last 7 days. */
export function isAssetYoungerThanOneWeek(
  data: Record<string, unknown>,
  nowMs = Date.now(),
): boolean {
  const createdMs = parseAssetCreatedMs(data);
  if (createdMs === null) {
    return false;
  }
  return nowMs - createdMs < ONE_WEEK_MS;
}

/**
 * Home carousel sub-title. Uses API `sub_title` when present; otherwise
 * "new on the market" (< 1 week) or "prime location" (older).
 */
export function assetRecordHomeSubTitle(data: Record<string, unknown>, t: TranslateFn): string {
  const fromApi = assetRecordSubTitle(data);
  if (fromApi) {
    return fromApi;
  }
  if (isAssetYoungerThanOneWeek(data)) {
    return t('home.assetSubTitleNew');
  }
  return t('home.assetSubTitlePrime');
}
